<template>
  <div class="admin">

    <div class="admin-area">

      <div class="row row-gutter-20">
        <div class="col-6">
          <admin-nav></admin-nav>
        </div>
        <div class="col-18">

          <header class="admin-header cf">
            <ul class="nav nav-header cf">
              <li><router-link to="/admin/vehicle_makes">Marken</router-link></li>
              <li>Marke hinzufügen</li>
            </ul>
            <div class="header-actions">
              <p><router-link to="/admin/vehicle_makes" class="button button-grey button-small">Alle Marken ›</router-link></p>
            </div>
          </header>

          <div class="admin-body">

            <form @submit="create_vehicle_make" class="form" method="post">

              <div class="form-wrap">
                <label for="name">Name</label>
                <input v-model="vehicle_make.name" class="form-input" type="text" name="name" id="name" placeholder="Name">
              </div>

              <p>
                <input type="submit" value="Marke erstellen ›" class="button button-orange button-small">
              </p>

            </form>

          </div>

        </div>
      </div>

    </div>

  </div>
</template>

<script>
import axios from 'axios'
import AdminNav from '../../../components/admin_nav'

export default {
  name: 'admin_reservations',
  components: {
    AdminNav
  },
  data () {
    return {
      vehicle_make: {}
    }
  },
  methods: {
    create_vehicle_make: function (e) {
      e.preventDefault();

      axios.post(process.env.VUE_APP_BASE_API+'/v1/admin/vehicle_makes', this.vehicle_make, { headers: { Authorization: this.$store.getters.getToken }})
      .then(response => {
        console.log(response);
        this.$router.push('/admin/vehicle_makes');
      })
      .catch(error => {
        error.response.data.errors.forEach(val => {
          this.$notify({
            group: 'alert',
            type: 'error',
            title: val,
          });
        })
      })

    }
  },
  mounted () {}
}
</script>

<style lang="scss">

</style>
